import axios from 'axios';
import {
  getAccessToken,
  liffGetProfile,
} from './promotion/auth.service';
import { getCustomerFOA } from './promotion/foa.service';
import CustomSweetAlert from '../common/customSweetAlert/CustomSweetAlert';
import config from '../config';

const liff = window.liff;
const AxiosInterceptor = axios.create({
  timeout: process.env.NETWORK_TIMEOUT,
});

export const clearFacadeToken = () => {
  sessionStorage.removeItem('facadeToken');
};

export const setFacadeToken = async (accessToken) => {
  return sessionStorage.setItem('facadeToken', JSON.stringify(accessToken));
};

export const isNotValidSessionABOMember = (facadeToken, customer) => {
  return (
    !facadeToken ||
    facadeToken.account.accountType.toLowerCase() !==
    customer.type.toLowerCase()
  );
};

export const getFacadeToken = async () => {
  const facadeToken = sessionStorage.getItem('facadeToken');
  return facadeToken && facadeToken !== 'undefined'
    ? JSON.parse(facadeToken)
    : null;
};

export const createLogs = async (data) => {
  try {
    await AxiosInterceptor.post(
      `${config.API_URL}/utils/create-logs`, data
    );
  } catch (error) {
    throw error;
  }
};

AxiosInterceptor.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  config.headers.authorization = `Bearer ${token}`;
  const liffProfile = await liffGetProfile();
  const customer = await getCustomerFOA(liffProfile.userId);
  config.headers.account = `${customer?.amwayNumber}`;
  config.headers.customer = `${customer?.partyId}`;
  return config;
});

AxiosInterceptor.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      CustomSweetAlert({
        title: "",
        text: "Request timed out",
        confirmButtonText: "ตกลง",
      });
      console.error('Request timed out');
    }
    if (
      (error.response !== undefined && error.response.status === 401) ||
      error.response.status === 403
    ) {
      sessionStorage.removeItem('facadeToken');
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default AxiosInterceptor;